import React, { useRef, useState, useEffect } from "react";
import { FaGithub, FaLinkedin, FaTwitter } from "react-icons/fa";

const socials = [
  { name: "GitHub", link: "https://github.com/vatsalkoriya", icon: <FaGithub size={28} /> },
  { name: "LinkedIn", link: "https://www.linkedin.com/in/vatsal-koriya-bb775233a/", icon: <FaLinkedin size={28} /> },
  { name: "Twitter", link: "https://twitter.com/vatsalkoriya", icon: <FaTwitter size={28} /> },
];

export default function Socials({ id }) {
  const [isVisible, setIsVisible] = useState(false);
  const sectionRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
          observer.disconnect(); // stop observing after animation
        }
      },
      { threshold: 0.3 }
    );

    if (sectionRef.current) observer.observe(sectionRef.current);

    return () => observer.disconnect();
  }, []);

  return (
    <section
      ref={sectionRef}
      id={id}
      className={`text-center mt-12 transition-opacity duration-1000 ${
        isVisible ? "opacity-100" : "opacity-0"
      }`}
    >
      <h2 className="text-3xl font-semibold mb-8">Find me on</h2>
      <div className="flex justify-center gap-12 text-blue-600 text-lg font-semibold">
        {socials.map(({ name, link, icon }, index) => (
          <a
            key={name}
            href={link}
            target="_blank"
            rel="noopener noreferrer"
            className={`flex flex-col items-center transform transition-all duration-700 ${
              isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-5"
            }`}
            style={{ transitionDelay: `${index * 150}ms` }} // stagger animation
          >
            {icon}
            <span className="mt-2">{name}</span>
          </a>
        ))}
      </div>
    </section>
  );
}
